export const VIEW_OPTIONS = { allOrganizations: 'All Organizations', hiddenOrganizations: 'Hidden' }
export const HIDDEN_WEBSITES_QUERY_KEY = 'hiddenWebsites'
export const HIDABLE_WEBSITES_QUERY_KEY = 'hidableWebsites'
